import cuid from 'cuid';

import { Image } from '@/domains/media';

export const generateImageId = (prefix) => `${prefix}-${cuid()}`;
export const addIdIfMissing = ({ id, ...rest }: Image) => ({ id: id ? id : generateImageId('r'), ...rest });
